import { groupBy, mapValues } from "lodash";

export enum TripTagCategory {
  MOST_POPULAR = "Najpopularniejsze",
  COUNTRY = "Kraj",
  GROUP_TYPE = "Rodzaj grupy",
  TRANSPORTATION_TYPE = "Transport",
  DURATION = "Długość",
}

export function groupTagsByCategory(
  tags: { readonly category: string; readonly value: string }[],
): Record<string, string[]> {
  return mapValues(
    groupBy(tags, (t) => t.category),
    (tags) => tags.map(({ value }) => value),
  );
}
